import { render } from "./compose.vue?vue&type=template&id=bfbe566e"
import script from "./compose.vue?vue&type=script&lang=js"
export * from "./compose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__